import { Injectable } from '@angular/core';
import { SuppliersModel } from '../../../models/master-data/suppliers.model';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
import { BaseService } from '../../../shared/services/base.service';
@Injectable()
export class SuppliersService {
    constructor(public baseService: BaseService) {

    }

    getSupplierList(param){
        const url = MasterDataUrl.GET_ALL_SUPPLIER;
        return this.baseService.getData(url, param);
    }

    addNewSupplier(param){
        const url = MasterDataUrl.ADD_SUPPLIER;
        return this.baseService.postData(url, param);
    }

    updateSupplier(id, param) {
        const url = MasterDataUrl.UPDATE_SUPPLIER + `${id}`;
        return this.baseService.update(url, param);
    }

    deleteSupplier(id) {
        const url = MasterDataUrl.REMOVE_SUPPLIER.replace('{id}', id);
        return this.baseService.delete(url);
    }

    getSupplier(id) {
		const url = MasterDataUrl.GET_SUPPLIER.replace('{id}', id);
        return this.baseService.getData(url);
    }

}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/suppliers/suppliers.service.ts